module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navbar"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand logo",
    staticStyle: {
      "padding": "0 10px 0"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "src": require("assets/img/logo2.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'crowdfunding'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.explore")))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/how_it_works"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.howItWorks")))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/start_campaign"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.startCampaign")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 nav-search"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.title),
      expression: "search.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "search projects"
    },
    domProps: {
      "value": (_vm.search.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.findProjects()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), (!_vm.user.email) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.fbLogin()
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-facebook-official domore-blue-1"
  }), _vm._v(" " + _vm._s(_vm.$t("header.connect")))])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn-link",
    on: {
      "click": function($event) {
        _vm.showSignup = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.signupButton")))])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn-link",
    on: {
      "click": function($event) {
        _vm.showLogin = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.loginButton")))])])]) : _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "user-nav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit_profile'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.yourProfile")))]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "user-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit_profile',
        query: {
          tab: 'campaigns'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.myCampaigns")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "user-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit_profile',
        query: {
          tab: 'about'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.aboutMe")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "user-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit_profile',
        query: {
          tab: 'delivery-address'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.delivery")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "user-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit_profile',
        query: {
          tab: 'organization'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.organization")))])], 1)])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t("header.logoutButton")))])])])])])]), _vm._v(" "), (_vm.showLogin) ? _c('login-modal', {
    attrs: {
      "close": _vm.closeLogin
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSignup) ? _c('signup-modal', {
    attrs: {
      "close": _vm.closeSignup
    }
  }, [_c('div', {
    attrs: {
      "slot": "errors"
    },
    slot: "errors"
  }, [_c('alert', {
    attrs: {
      "error": _vm.error
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11e669a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Index.vue
// module id = 779
// module chunks = 1